export default __webpack_public_path__ + "static/media/weapon-cleaning.f96275fb.jpg";